/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'funnel': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3.023 2.183a1.549 1.549 0 00-.761 2.319c.014.02.029.04.046.058l5.097 5.608v3.988c0 .159.075.308.202.403l4.183 3.137a.503.503 0 00.805-.403v-7.125l5.097-5.608a.501.501 0 00.046-.058 1.549 1.549 0 00-.774-2.323.504.504 0 00-.167-.029H3.215a.5.5 0 00-.192.033zm.28.974a.542.542 0 00-.221.759L8.28 9.635c.084.092.13.213.13.338v3.932l3.177 2.382V9.973c0-.125.047-.246.131-.338l5.2-5.72a.543.543 0 00-.222-.758H3.303z" _fill="#1D3861"/>'
  }
})
